export default __webpack_public_path__ + "static/media/logo-lb-sm.32b86ac4.svg";